import { routes } from './../../../app.routes';
import { Component } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { BackToTopComponent } from '../back-to-top/back-to-top.component';
@Component({
  selector: 'app-footer',
  imports: [SharedModule, RouterLink, BackToTopComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {}
